import axios from 'axios';
import { getOnlyToken } from './commonFunctions';

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
// console.log("BASE_URL", BASE_URL);

const apiClient = axios.create({
    baseURL: BASE_URL,
    withCredentials: true, // ✅ Required for sending & receiving cookies and 🔐 Required for cookie-based refresh
});

// Add a request interceptor to set the Authorization header dynamically
apiClient.interceptors.request.use((config) => {
    const token = getOnlyToken();
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
    }
    // Dynamically set 'Content-Type' header for FormData
    if (config.data instanceof FormData) {
        config.headers['Content-Type'] = 'multipart/form-data';
    } else {
        config.headers['Content-Type'] = 'application/json';
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});
// // Response interceptor: auto-refresh token on 401
// apiClient.interceptors.response.use(
//     (response) => response,
//     async (error) => {
//         const originalRequest = error.config;

//         // Token expired and not already retried
//         if (
//             error.response?.status === 401 &&
//             !originalRequest._retry &&
//             !originalRequest.url.includes("/token/refresh")
//         ) {
//             originalRequest._retry = true;

//             try {
//                 // Make request to refresh endpoint — assumes refresh token is in cookie
//                 const { data } = await axios.post(
//                     `${BASE_URL}/auth/token/refresh/`,
//                     {},
//                     {
//                         withCredentials: true, // Send the cookie
//                     }
//                 );

//                 const newAccessToken = data?.access;
//                 if (newAccessToken) {
//                     // setToken(newAccessToken); // save to localStorage or context
//                     // Retry original request with new token
//                     originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
//                     return apiClient(originalRequest);
//                 } else {
//                     throw new Error("No new access token received");
//                 }
//             } catch (refreshError) {
//                 console.error("Refresh token failed", refreshError);
//                 // clearToken(); // clear localStorage or any saved state
//                 window.location.href = "/login"; // force login
//                 return Promise.reject(refreshError);
//             }
//         }

//         return Promise.reject(error);
//     }
// );

// Define common API methods
export const _get = (url, config = {}) => {
    return apiClient.get(url, config);
};

export const _delete = (url, config = {}) => {
    return apiClient.delete(url, config);
};

export const _put = (url, data = {}, config = {}) => {
    return apiClient.put(url, data, config);
};

export const _post = (url, data = {}, config = {}) => {
    return apiClient.post(url, data, config);
};

export const _patch = (url, data = {}, config = {}) => {
    return apiClient.patch(url, data, config);
};

export const signupCustomer = (api_input) => {
    return _post('api/auth/register/', api_input);
}

export const verifyCustomerEmail = (api_input) => {
    return _post('user/verify-email/', api_input);
}
export const loginCustomer = (api_input) => {
    return _post('api/auth/login/', api_input);
}
export const forgotPassword = (api_input) => {
    return _post('api/auth/forgot-password/', api_input);
}
export const resendOtp = (api_input) => {
    return _post('api/auth/resend-2fa/', api_input);
}
export const updateUserPassword = (api_input) => {
    return _post('api/auth/reset-password/', api_input);
}
export const captchrefresh = async () => {
    return await _get('api/auth/generate-captcha/');
};

export const otpVerification = (api_input) => {
    return _post('api/auth/verify-2fa/', api_input);
}


//Plans
export const getPlans = () => {
    return _get('api/auth/plans/');
}

//Profile
export const getProfileDetails = () => {
    return _get('api/auth/profile/');
}
export const updateProfile = (api_input) => {
    return _put('api/auth/profile/', api_input);
}
///////////// tickets ////////////////

export const fetchTicketListData = (params) => {
    const response = _post(`api/support/tickets_list`, params);
    return response;
}

export const fetchTicketDetailsData = (params) => {
    const response = _get(`api/support/ticket_details/${params?.ticket_number}/`);
    return response;
}

export const addTicketReply = (ticket_number, params) => {
    const response = _put(`api/support/ticket_update/${ticket_number}/update/`, params);
    return response;
};

export const fetchParentTickect = (api_input) => {
    return _get('api/support/get_ticket_parent_category', api_input);
};

export const fetchParentCreateTickect = (parcategory, api_input) => {
    return _get(`api/support/get_ticket_category?parent_category=${parcategory}`, api_input);
};

export const fetchCreateTicket = (api_input) => {
    return _post(`api/support/create_ticket`, api_input);
};


export const fetchCountryList = (api_input) => {
    const response = _get(`api/auth/countries`, api_input);
    return response;
};

export const fetchStateList = (id) => {
    const response = _get(`api/auth/states/?country_id=${id}`);
    return response;
};


export const otpRegistration = (api_input) => {
    return _post('api/auth/verify-signup-otp/', api_input);
}



export const resendOtpRegistration = (api_input) => {
    return _post('api/auth/resend-signup-otp/', api_input);
};

// 

export const getFolderList = (page_size = 10, page_number = 1, search = "") => {
    const params = new URLSearchParams();
    params.append('page_size', page_size);
    params.append('page_number', page_number);
    if (search.trim()) {
        params.append('search', search);
    }
    return _get(`api/agents/folder/create/?${params.toString()}`);
}

export const getFolders = (page_size = 10, page_number = 1, search = "") => {
    const params = new URLSearchParams();
    if (search.trim()) {
        params.append('search', search);
    }
    return _get(`api/agents/folder/create/?${params.toString()}`);
}

export const SaveFolderName = (api_input) => {
    return _post('api/agents/folder/create/', api_input);
}
export const UpdateFolderName = (data) => {
    const response = _put(`api/agents/folder/update/`, data);
    return response;
};

export const DeleteFolderName = (id) => {

    return apiClient.request({
        url: "api/agents/folder/delete/",
        method: "DELETE",
        data: { folder_id: id }
    });

}

export const DeleteAgentByID = (id) => {

    return apiClient.request({
        url: `api/admin/agent/delete/`,
        method: "DELETE",
        data: { agent_id: id }
    });

}
export const CreateAgentBasic = (api_input) => {
    return _put('api/admin/agent/update/', api_input);
}
export const UpdateAgentBasic = (api_input) => {
    return _put('api/admin/agent/update/', api_input);
}




export const LLMandVoiceConfiguration = (api_input) => {
    return _put(`api/agents/llm-voice-config/update/?agent_id=${api_input.agent_id}`, api_input);
}

export const LLMandVoiceConfigurationUpdate = (api_input) => {
    return _put(`api/agents/llm-voice-config/update/?agent_id=${api_input.agent_id}`, api_input);
}


export const TranscriberProviderAPI = (api_input) => {
    return _put(`api/agents/transcriber/?agent_id=${api_input.agent_id}`, api_input);
}

export const TranscriberProviderUpdateAPI = (api_input) => {
    return _put(`api/agents/transcriber/?agent_id=${api_input.agent_id}`, api_input);
}


export const PredefinedFunctionsAPI = (api_input) => {
    return _put(`api/agents/predefined-functions/?agent_id=${api_input.agent_id}`, api_input);
}

export const PredefinedFunctionsUpdateAPI = (api_input) => {
    return _put(`api/agents/predefined-functions/?agent_id=${api_input.agent_id}`, api_input);
}


export const AgentSummaryAPI = (api_input) => {
    return _put(`api/agents/summary-configuration/?agent_id=${api_input.agent_id}`, api_input);
}

export const AgentSummaryUpdateAPI = (api_input) => {
    return _put(`api/agents/summary-configuration/?agent_id=${api_input.agent_id}`, api_input);
}


export const CallPrivacyAPI = (api_input) => {
    return _put(`api/agents/call-privacy/?agent_id=${api_input.agent_id}`, api_input);
}

export const CallPrivacyUpdateAPI = (api_input) => {
    return _put(`api/agents/call-privacy/?agent_id=${api_input.agent_id}`, api_input);
}


export const getAIAgentsbyFolder = (search = "") => {
    return _get(`api/agents/folder-wise/agents/?search=${search}`);
};



export const getAIAgentsbyID = (id) => {
    return _get(`api/agents/detail/?agent_id=${id}`);
}

export const getAIAgentsbyIDLLMData = (id) => {
    return _get(`api/agents/llm-voice-config/?agent_id=${id}`);
}

export const getAIAgentsbyIDTranscriber = (id) => {
    return _get(`api/agents/transcriber/?agent_id=${id}`);
}

export const getAIAgentsbyIDSummary = (id) => {
    return _get(`api/agents/summary-configuration/?agent_id=${id}`);
}
export const getAIAgentsbyIDPredefinedFunctions = (id) => {
    return _get(`api/agents/predefined-functions/?agent_id=${id}`);
}

export const getAIAgentsbyIDCallPrivacy = (id) => {
    return _get(`api/agents/call-privacy/?agent_id=${id}`);
}

export const getCallingoActivityLog = (pagesize, page) => {
    return _get(`api/auth/activity-log/?page_number=${page}&page_size=${pagesize}`);
}

export const getPaymentHistoryList = (api_input) => {
    return _post(`api/billing/payment-history/`, api_input);

}
export const getCallLogFormAPIList = (url) => {
    return _get(`${url}`);

}

export const getLLMConfigurationsList = () => {
    return _get(`api/agents/list-llm-providers/`);
}

export const SaveLLMConfig = (api_input) => {
    return _post('api/agents/llm-config/', api_input);
}
export const UpdateLLMConfig = (data) => {
    const response = _put(`api/agents/llm-config/${data.folder_id}/`, data);
    return response;
};


export const DeleteLLMConfig = (id) => {
    const response = _delete(`api/agents/llm-config/${id}/`);
    return response;
};


export const getVoiceConfigurationsList = () => {
    return _get(`api/agents/list-tts-providers/`);
}

export const getVoiceModelList = () => {
    return _get(`api/agents/get-tts-voices/`);
}

export const SaveVoiceConfigs = (api_input) => {
    return _post('api/agents/voice-config/', api_input);
}
export const UpdateVoiceConfigs = (data) => {
    const response = _put(`api/agents/voice-config/${data.folder_id}/`, data);
    return response;
};


export const DeleteVoiceConfigs = (id) => {
    const response = _delete(`api/agents/voice-config/${id}/`);
    return response;
};


export const getTranscriberConfigs = () => {
    return _get(`api/agents/list-stt-providers/`);
}

export const getTranscriberLanguage = () => {
    return _get(`api/agents/get-speech-to-text/`);
}

export const SaveTranscriberConfigs = (api_input) => {
    return _post('api/agents/transcriber-config/', api_input);
}
export const UpdateTranscriberConfigs = (data) => {
    const response = _put(`api/agents/transcriber-config/${data.folder_id}/`, data);
    return response;
};


export const DeleteTranscriberConfigs = (id) => {
    const response = _delete(`api/agents/transcriber-config/${id}/`);
    return response;
};

export const SendBulkCallFiles = (api_input) => {
    return _post('api/agents/excel-upload/', api_input, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}

export const SendBulkMakeCalls = (api_input) => {
    return _post('api/agents/call/initiate/', api_input);
}